import { TransformedLayer } from '../utils/resourceUtils'; 
export interface Product {
  id: string;
  name: string;
  category: string;
  price: number;
  image: string;
  description: string;
  customizable: boolean;
  templates: Template[];
  previews?: Preview[];
  colors: Color[];
  sizes: Size[];
  rating?: number;
  code?:string;
  reviews?: number;
  // 逗号分隔的轮播图图片地址字符串
  sliderImages?: string;
}

export interface Template {
  id: string;
  name: string;
  preview: string;
  design?: ProductDesign;  
}

export interface Color {
  id: string;
  name: string;
  hex: string;
  available: boolean;
}

export interface Size {
  id: string;
  name: string;
  dimensions: string;
  price: number;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  href: string;
  products: Product[];
  subCategories?: SubCategory[];
}

export interface NavigationItem {
  id: string;
  name: string;
  href: string;
  hasDropdown?: boolean;
  subCategories?: SubCategory[];
  background?: string;
  textColor?: string;
  fontWeight?: string | number;
}

export interface SubCategory {
  id: string;
  name: string;
  href: string;
}

export interface CartItem {
  id: string;
  code: string;
  name: string;
  price: number;
  quantity: number;
  size: string;
  color: string;
  image: string;
  customizable: boolean;
}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  createdAt: string;
  phone: string;
  addresses: Address[];
  defaultAddressId?: string;
}
 

export interface ProductDesign {
  view: string;
  mask: string;
  backgrounds: any[];
  covers: any[];
  faces: {
    background?: {
      texture?: string;
      image?: string;
      color?: string;
    };
    code: string;
    demo: string;
    obj?: string;
    position?: {
      x: number;
      y: number;
      z: number;
    };
    scale?: {
      x: number;
      y: number;
      z: number;
    };
    rotation?: {
      x: number;
      y: number;
      z: number;
    };
    layers: TransformedLayer[];
    print_area?: {
      left: number;
      top: number;
      width: number;
      height: number;
    };
  }[];
}
export interface Preview {
  type: string;
  url: string;
  options: any;
}
export interface Address {
  id: string;
  type: 'home' | 'work' | 'other';
  firstName: string;
  lastName: string;
  company?: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  phone: string;
  isDefault: boolean;
}

export const categories: Category[] = [ 
];

export const navigationItems: NavigationItem[] = [
 
  {
    id: 'create-your-own',
    name: 'Create Your Own',
    href: '/products',
    hasDropdown: true,
    subCategories: [    ]
  },
  {
    id: 'gifts',
    name: 'AI Tee !!',
    href: '/products?ai=tee', 
    textColor: '#cb59eeff',
    fontWeight: 700
  }
];

export const products: Product[] = [ 
];

// 初始化分类产品
categories.forEach(category => {
  category.products = products.filter(product => product.category === category.id);
});

// 购物车Mock数据
export const cartItems: CartItem[] = [
   
];

// 计算购物车总数量
export const getCartItemCount = (): number => {
  return cartItems.reduce((total, item) => total + item.quantity, 0);
};

// 计算购物车总价
export const getCartTotal = (): number => {
  return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
};

// 添加商品到购物车
export const addToCart = (code:string,product: Product, quantity: number, size?: string, color?: string, customImage?: string): void => {
  const newCartItem: CartItem = {
    id: `cart-${Date.now()}`,
    code: code||product.id,
    name: product.name,
    price: product.price,
    quantity: quantity,
    size: size || 'Standard',
    color: color || 'Default',
    image: customImage || '☕',
    customizable: product.customizable
  };

  cartItems.push(newCartItem);
  
  // 通知购物车状态更新
  const event = new CustomEvent('cartUpdated', { detail: cartItems });
  window.dispatchEvent(event);
};

// 从购物车删除商品
export const removeFromCart = (itemId: string): void => {
  const index = cartItems.findIndex(item => item.id === itemId);
  if (index !== -1) {
    cartItems.splice(index, 1);
  }
};

// Mock用户数据
export const mockUsers: User[] = [];

// 用户认证相关函数
export const loginUser = (email: string, password: string): User | null => {
  // 模拟登录验证
  const user = mockUsers.find(u => u.email === email);
  if (user && password === 'password123') { // 模拟密码验证
    // 保存到本地存储
    localStorage.setItem('currentUser', JSON.stringify(user));
    return user;
  }
  return null;
};

export const logoutUser = (): void => {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('currentUser');
};

export const getCurrentUser = (): User | null => {
  const userStr = localStorage.getItem('currentUser');
  return userStr ? JSON.parse(userStr) : null;
};

export const isUserLoggedIn = (): boolean => {
  return getCurrentUser() !== null;
};

export const designElements = {
  fonts: [
    { id: 'arial', name: 'Arial', family: 'Arial, sans-serif' },
    { id: 'helvetica', name: 'Helvetica', family: 'Helvetica, Arial, sans-serif' },
    { id: 'times', name: 'Times New Roman', family: 'Times New Roman, serif' },
    { id: 'georgia', name: 'Georgia', family: 'Georgia, serif' },
    { id: 'roboto', name: 'Roboto', family: 'Roboto, sans-serif' }
  ],
  shapes: [
    { id: 'circle', name: 'Circle', icon: '⭕' },
    { id: 'square', name: 'Square', icon: '⬜' },
    { id: 'triangle', name: 'Triangle', icon: '🔺' },
    { id: 'star', name: 'Star', icon: '⭐' },
    { id: 'heart', name: 'Heart', icon: '❤️' }
  ],
  effects: [
    { id: 'shadow', name: 'Drop Shadow' },
    { id: 'glow', name: 'Glow' },
    { id: 'blur', name: 'Blur' },
    { id: 'gradient', name: 'Gradient' }
  ]
};
